(function () {
  const REPLACEMENTS = [
    ['x', 'y'],
    ['Magnesium Glycinate 90 Capsules', 'Ivrmectin'],
    // istediğin kadar çift ekle
  ];

  function replaceAll(root = document.body) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const tag = node.parentNode?.nodeName;
        if (tag === 'SCRIPT' || tag === 'STYLE') return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });
    let node;
    while ((node = walker.nextNode())) {
      let v = node.nodeValue;
      for (const [s, r] of REPLACEMENTS) {
        if (v.includes(s)) v = v.split(s).join(r);
      }
      if (v !== node.nodeValue) node.nodeValue = v;
    }
  }

  function run() { replaceAll(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', (e) => replaceAll(e.target));

  new MutationObserver((muts) => {
    muts.forEach((m) => m.addedNodes.forEach((n) => {
      if (n.nodeType === 1) replaceAll(n);
    }));
  }).observe(document.body, { childList: true, subtree: true });
})();